import { styled } from '@mui/material/styles';
import { Box, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import dynamic from 'next/dynamic';
import React from 'react';
import { parseTabData } from '../../../../../utils/helpers';

const CumulativeReturns = dynamic(() => import('./CumulativeReturns'))
const FiveTwoRange = dynamic(() => import('../FiveTwoRange'))

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  // height: useMediaQuery((theme) => theme.breakpoints.down('sm')) ? '' : '100%',
  color: theme.palette.text.secondary,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    fontSize: '.7rem',
    background: '#f2f2f2',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: ' 0 8px 0 8px',
    borderRadius: '6px 6px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 500,
      color: '#333',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(.7, 0),
    color: '#13113c'
  }
}));


const PriceAction = ({ tabData, themes, info, flex, data, riskDrawdown }) => {
  const { realtime_stock_data, } = info || {}
  let latest_metrics = tabData && tabData.length > 0 ? tabData.find(d => d.section_code === "latest_metrics") : null;
  latest_metrics = latest_metrics ? parseTabData(latest_metrics) : null

  return (
    <>
      {realtime_stock_data && latest_metrics &&
        <Grid size={{ xs: 12, sm: 12 }} >
          <Item component="div" className="about-company" sx={{ mb: 0 }}>
            <Box
              className="Item-Head"
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                mb: 0.5,
                px: 0.5,
              }}
            >
              {/* <Typography component="h3" className="option-title" sx={{ mr: 'auto', fontSize: '.875rem !important' }} >
                {`Breaking Down XXXXX Revenue`.replace(/XXXXX/g, `${info?.ticker}`)}
              </Typography> */}
              <Typography component="h3" className="option-title" sx={{ mr: 'auto', fontSize: '.875rem !important' }} >
                {`XXXXX Price Action`.replace(/XXXXX/g, `${info?.ticker}`)}
              </Typography>
            </Box>
            <FiveTwoRange
              info={info}
              data={data}
              realtime_stock_data={realtime_stock_data}
            />
            <CumulativeReturns
              tabData={tabData}
              info={info}
              latest_metrics={latest_metrics}
            />
            {riskDrawdown}
          </Item>
        </Grid>}
    </>
  );
}

// export default withSubscribe(withLoader((Returns)));
export default React.memo(PriceAction);
